//  错误窗体
function errorForms (data) {
  $('body').prepend("<div class='alert alert-danger' role='alert'>" + data + '</div>')
}

//  全局Token变量
var token = ''


// function getJson (url, data) {
//   if (token === '') {
//     getToKen()
//   }
//   var shuju = new String()
//   $.ajax({
//     type: 'POST',
//     headers: {
//       Accept: 'application/json; charset=utf-8',
//       token: token
//     },
//     async: false,
//     contentType: 'application/json;charset=UTF-8',
//     url: 'https://rcrmyy.wanjiadayuan.com:877' + url,
//     // url: 'http://10.1.13.238:8081/' + url,'https://rcrmyy.wanjiadayuan.com:877'
//     data: data,
//     success: function (result) {
//       if (result === '认证失败') {
//         getToKen()
//         getJson(url, data)
//         return
//       }
//       // console.log('ajax')
//       shuju = JSON.stringify(result)
//     },
//     error: function (e) {
//       console.log(e.status)
//       console.log(e.responseText)
//     }
//   })
//
//   // console.log('getJson')
//
// //当登录失败后，JSON.parse会自动转换为空字符串
//   if(shuju=='""' || shuju.length==0){
//     return '{"success": false}'
//   }else{
//     // console.log(shuju)
//     return JSON.parse(shuju)
//   }
//
//
// }


function getJson(url, parameters) {
  console.log(url)
  console.log(parameters)
  var status = 200
  if (true) {
      fetch(realURL, {
          method: "POST",
          body: JSON.stringify(parameters),
          headers: {
              "Content-type": "application/json; charset=UTF-8",
              "token":'eyJ0eXAiOiJKV1QiLCJseCI6ImprIiwic3lyIjoieHhrIiwiYWxnIjoiSFMyNTYifQ.eyJlbnRlcnByaXNlSWQiOiIyIiwiZXhwIjoxNTgwODg2ODE0fQ.JHI3IK-lapY_wjEvdPk0TkYat8ujpkbJTz7T9ng57eg'
          }
      })
          .then(response => {
              status = response.status
              return response.text()
          })
          .then(function (json) {
              if (typeof callback === "function") {
                  if (status === 200) {
                     console.log(json)
                  } else {
                      console.log("失败")
                  }
              }
          })
  } else if (responseCode === ResponseCode.failure) {
      console.log("验证码服务器错误")
  } else if (responseCode === ResponseCode.unresponse) {
    console.log("验证码获取为空")
  } else {
    console.log("未知错误")
  }
}


function getJson1 (url, data) {







//   const realURL = 'https://rcrmyy.wanjiadayuan.com:877' + url
//   if (token === '') {
//     getToKen()
//   }
//   var shuju = new String()
//   fetch(realURL, {
//     method: 'POST',
//     body: data,
//     headers: {
//       'Content-type': "application/json; charset=UTF-8",
//       'token': token
//     }
//   }).then(function(response) {
//     if (response.status >= 200 && response.status < 300) {
//       return response.text()
//     } else {
//       const error = new Error(response.statusText)
//       error.response = response
//       throw error
//     }
//   }).then(function(result) {
//     if (result === '认证失败') {
//       getToKen()
//       getJson(realURL, data)
//       return
//     }
//     shuju = result
//   }).catch(function(error) {
//     shuju = '{"success": false}'
//   })
//
//   if(shuju==='""' || shuju.length===0){
//     return '{"success": false}'
//   }else{
//     return shuju
//   }
}

//  获取token方法
function getToKen () {
  var loginMap = '{"enterpriseDl":"waiwangzhuanyong","enterpriseMm":"fbf93963ec9711e99e6b00505690132d"}'
  const url = 'https://rcrmyy.wanjiadayuan.com:877/login'
  // const url = 'http://10.1.13.238:8080/login'
  fetch(url, {
    method: 'POST',
    body: loginMap,
    headers: {
      'Content-type': "application/json; charset=UTF-8"
    }
  }).then(function(response) {
    if (response.status >= 200 && response.status < 300) {
      return response.text()
    } else {
      const error = new Error(response.statusText)
      error.response = response
      throw error
    }
  }).then(function(result) {
    if (result === '认证失败') {
      console.log('gettoken' + result)
      errorForms('ToKen认证失败如多次失败请联系医院信息科查看')
    } else {
      token = result
    }
  }).catch(function(error) {
    console.log('gettoken:' + error)
  })
  // $.ajax({
  //   type: 'POST',
  //   async: false,
  //   contentType: 'application/json;charset=UTF-8',
  //   url: 'https://rcrmyy.wanjiadayuan.com:877/login',//https://rcrmyy.wanjiadayuan.com:877/login
  //   // url: 'http://10.1.13.238:8081/login',https://rcrmyy.wanjiadayuan.com:877
  //   data: loginMap,
  //   success: function (result) {
  //     if (result === '认证失败') {
  //       console.log('gettoken' + result)
  //       errorForms('ToKen认证失败如多次失败请联系医院信息科查看')
  //     }
  //     token = result
  //   },
  //   error: function (e) {
  //     console.log(e.status)
  //     console.log(e.responseText)
  //   }
  // })
}


// function getToKen () {
//   var loginMap = '{"enterpriseDl":"waiwangzhuanyong","enterpriseMm":"fbf93963ec9711e99e6b00505690132d"}'
//   $.ajax({
//     type: 'POST',
//     async: false,
//     contentType: 'application/json;charset=UTF-8',
//     url: 'https://rcrmyy.wanjiadayuan.com:877/login',//https://rcrmyy.wanjiadayuan.com:877/login
//     // url: 'http://10.1.13.238:8081/login',https://rcrmyy.wanjiadayuan.com:877
//     data: loginMap,
//     success: function (result) {
//       if (result === '认证失败') {
//         console.log('gettoken' + result)
//         errorForms('ToKen认证失败如多次失败请联系医院信息科查看')
//       }
//       token = result
//     },
//     error: function (e) {
//       console.log(e.status)
//       console.log(e.responseText)
//     }
//   })
// }

export {
  errorForms,
  getJson
}



// WEBPACK FOOTER //
// ./src/assets/js/httpjson.js